export function Youtube({ src }: { src: string }) {
  return (
    <div className="relative w-full pb-[56.25%]">
      <iframe
        className="absolute left-0 top-0 h-full w-full"
        src={src}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  )
}

export function GoogleSlides({ src }: { src: string }) {
  return (
    <iframe
      className="aspect-[16/10] w-full"
      src={src}
      title="Google slides viewer"
      frameBorder="0"
      allowFullScreen={true}
      allow="fullscreen"
    ></iframe>
  )
}
